<template>
  <div v-if="showDirectFlights && timeItems.length > 0" class="space-y-2">
    <h3
      v-if="isRoundTrip"
      class="text-text-neutral-primary text-base font-semibold"
    >
      {{
        directionIndex === 0
          ? t('search.directFlights.outbound')
          : t('search.directFlights.return')
      }}
    </h3>
    <TimeList
      class="-mx-4"
      :time-items="timeItems"
      @onTimeClick="handleTimeClick"
    />
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import TimeList from './TimeList.vue';
  import type { TimeItem } from '../types';

  const props = defineProps<{
    showDirectFlights: boolean;
    timeItems: TimeItem[];
    isRoundTrip: boolean;
    directionIndex: number;
  }>();

  const emit = defineEmits<{
    onTimeClick: [item: TimeItem];
  }>();

  const { t } = useI18n();

  const handleTimeClick = (item: TimeItem) => {
    emit('onTimeClick', item);
  };
</script>
